import React, { useState, useEffect } from 'react';
import { API_URLS } from './config';

// Only store user answers & submissions in bulkData
const initialBulkData = {};

const UserContext = React.createContext();

export const UserProvider = ({ children }) => {
  const [bulkData, setBulkData] = useState(() => {
    try {
      const savedData = localStorage.getItem('bulkData');
      const parsedData = savedData ? JSON.parse(savedData) : null;
      // Ensure parsedData is not null before returning, default to initialBulkData
      return parsedData !== null ? parsedData : initialBulkData;
    } catch (error) {
      console.error("Failed to parse stored data", error);
      return initialBulkData;
    }
  });
  
  const [token, setToken] = useState(null);

  useEffect(() => {
    // Ensure we don't save 'null' to localStorage if bulkData somehow becomes null
    if (bulkData !== null) {
      localStorage.setItem('bulkData', JSON.stringify(bulkData));
    } else {
      // If bulkData is null, reset localStorage to initialBulkData
      localStorage.setItem('bulkData', JSON.stringify(initialBulkData));
    }
  }, [bulkData]);

  useEffect(() => {
    console.log("Fetching token from API...");
    console.log("API URL:", API_URLS.token);
    fetch(API_URLS.token)
      .then(response => response.json())
      .then(data => {
        setToken(data);
      })
      .catch(error => {
        console.error("Error fetching token:", error);
      });
  }, []);

  const value = {
    bulkData,
    setBulkData,
    token,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserContext;